import request from '@/utils/http'
import { SRM, SRM_FILE } from '../../constant/constant.js'

// 分页查询
export const getPerformanceList = data => {
    return request({
        url: `${SRM}/supplierWarehousePerformance/list`,
        method: 'post',
        data,
    })
}

// 导出
export const exportPerformance = data => {
    return request({
        url: `${SRM_FILE}/supplierWarehousePerformance/export`,
        method: 'post',
        data,
    })
}

// 废弃
export const deprecatePerformance = data => {
    return request({
        url: `${SRM}/supplierWarehousePerformance/deprecate`,
        method: 'post',
        data,
    })
}

// 确认
export const confirmPerformance = data => {
    return request({
        url: `${SRM}/supplierWarehousePerformance/confirm`,
        method: 'post',
        data,
    })
}

// 重新计算
export const recalculatePerformance = data => {
    return request({
        url: `${SRM}/supplierWarehousePerformance/recalculate`,
        method: 'post',
        data,
    })
}

// 详情
export const detailPerformance = data => {
    return request({
        url: `${SRM}/supplierWarehousePerformance/detail/${data}`,
        method: 'get',
        // data,
    })
}

// 公式计算
export const computePerformance = data => {
    return request({
        url: `${SRM}/supplierWarehousePerformance/realTimeCompute`,
        method: 'post',
        data,
    })
}

// 新增
export const addPerformance = data => {
    return request({
        url: `${SRM}/supplierWarehousePerformance/add`,
        method: 'post',
        data,
    })
}

// 编辑
export const editPerformance = data => {
    return request({
        url: `${SRM}/supplierWarehousePerformance/edit`,
        method: 'post',
        data,
    })
}

// 操作记录
export const getAuditList = data => {
    return request({
        url: `${SRM}/supplierMipAudit/list`,
        method: 'post',
        data,
    })
}

// 流程变更信息
export const getChangeInfo = data => {
    return request({
        url: `${SRM}/supplierWarehousePerformance/getChangeInfo/${data}`,
        method: 'get',
        // data,
    })
}

// 绩效考核废弃流程表单
export const getDeprecateInfo = data => {
    return request({
        url: `${SRM}/supplierWarehousePerformance/getDeprecateInfo/${data}`,
        method: 'get',
    })
}
